export default __webpack_public_path__ + "static/media/payment.inline.d6aa0f4a.svg";